import React, { useContext, useEffect, useState } from "react";
import { useParksQuery } from "../../generated/graphql";
import { ControlBarContext, looseObject } from "../controls/ControlBarContext";
import ParkCard from "./ParkCard";

function Parks() {
  const ctx = useContext(ControlBarContext);
  const [filters, setFilters] = useState<looseObject>({});

  useEffect(() => {
    setFilters(ctx.selection);
  }, [ctx]);

  const filter: any = {};

  Object.keys(filters).forEach((key) => {
    if (filters[key] && filters[key].length > 0) {
      filter[key] = { in: filters[key] };
    }
  });

  const { loading, data, error } = useParksQuery({
    variables: {
      input: { limit: 30, start: 0 },
      filter : {...filter}
    },
  });

  if (loading) {
    return <div>Loading ...</div>;
  }

  if (error) {
    return <div>Error</div>;
  }

  return (
    <div className="flex flex-wrap -mx-1 lg:-mx-4">
      {data?.parks.map(({ parkCode, name, fullName, states, images }) => (
        <ParkCard
          parkCode={parkCode}
          name={name}
          fullName={fullName}
          states={states}
          images={images}
        />
      ))}
    </div>
  );
}

export default Parks;
